import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { FormattedMessage } from 'react-intl';

const useStyles = makeStyles(theme => ({
  container: {
    padding: theme.spacing(4)
  },
  text: {
    color: theme.palette.grey[800]
  }
}));

const NoData = () => {
  const classes = useStyles();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      className={classes.container}
    >
      <Typography variant="subtitle2" classes={{ root: classes.text }}>
        <FormattedMessage id="table.noDataLabel" />
      </Typography>
    </Box>
  );
};

export default NoData;
